import {SupportedLocales} from '#types/locale.js';

export const deliverabilityDashboardLang = {
  [SupportedLocales.EN]: {
    deliverabilityDashboard: {
      title: 'Deliverability',
      freshness: (date: string) => `Data through ${date}`,
      controls: {
        channel: 'Channel',
        timeRange: 'Time range',
      },
      channels: {
        email: 'Email',
        sms: 'SMS',
      },
      timeRanges: {
        '7d': '7D',
        '30d': '30D',
        '90d': '90D',
      },
      metrics: {
        sent: 'Processed',
        delivered: 'Delivered',
        opens: 'Opens',
        unique_opens: 'Unique Opens',
        clicks: 'Clicks',
        unique_clicks: 'Unique Clicks',
        unsubscribes: 'Unsubscribes',
        bounces: 'Bounces',
        blocks: 'Blocks',
        drops: 'Drops',
        deferred: 'Deferred',
        undelivered: 'Undelivered',
        failed: 'Failed',
        spam_reports: 'Spam Reports',
        delivery_rate: 'Delivery Rate',
        open_rate: 'Open Rate',
        click_rate: 'Click Rate',
        unsubscribe_rate: 'Unsubscribe Rate',
      },
      outcomes: 'Outcomes',
      chart: {
        countTrend: 'Count trend',
        noTrendData: 'No trend data',
        loadError: 'Unable to load count trend.',
      },
      states: {
        invalidUrl: 'Invalid dashboard URL',
        resetDashboard: 'Reset dashboard',
        loading: 'Loading',
        metricsLoadError: 'Unable to load deliverability metrics.',
      },
    },
  },
  [SupportedLocales.ES]: {
    deliverabilityDashboard: {
      title: 'Entregabilidad',
      freshness: (date: string) => `Datos hasta ${date}`,
      controls: {
        channel: 'Canal',
        timeRange: 'Rango de tiempo',
      },
      channels: {
        email: 'Correo electrónico',
        sms: 'SMS',
      },
      timeRanges: {
        '7d': '7D',
        '30d': '30D',
        '90d': '90D',
      },
      metrics: {
        sent: 'Procesados',
        delivered: 'Entregados',
        opens: 'Aperturas',
        unique_opens: 'Aperturas únicas',
        clicks: 'Clics',
        unique_clicks: 'Clics únicos',
        unsubscribes: 'Cancelaciones de suscripción',
        bounces: 'Rebotes',
        blocks: 'Bloqueos',
        drops: 'Descartes',
        deferred: 'Diferidos',
        undelivered: 'No entregados',
        failed: 'Fallidos',
        spam_reports: 'Reportes de spam',
        delivery_rate: 'Tasa de entrega',
        open_rate: 'Tasa de apertura',
        click_rate: 'Tasa de clics',
        unsubscribe_rate: 'Tasa de cancelación de suscripción',
      },
      outcomes: 'Resultados',
      chart: {
        countTrend: 'Tendencia de conteo',
        noTrendData: 'No hay datos de tendencia',
        loadError: 'No se pudo cargar la tendencia de conteo.',
      },
      states: {
        invalidUrl: 'URL del dashboard no válida',
        resetDashboard: 'Restablecer dashboard',
        loading: 'Cargando',
        metricsLoadError:
          'No se pudieron cargar las métricas de entregabilidad.',
      },
    },
  },
};
